import { faMap } from "@fortawesome/free-solid-svg-icons"
import { RouteLink } from "../../../types/route-link"

const dashboardUserRouteLinks: Array<RouteLink> = [
    {
        path: "/user-dashboard",
        name: "Maps",
        icon: faMap,
    }
]

export default dashboardUserRouteLinks